/* tslint:disable */

/* eslint-disable */

/**
 * Jucy Rentals Rest API
 * In this document you will find all the API methods we provide along with explanations for parameters and response examples.  If you are using the legacy V2 API, [view the V2 documentation here.](/docs/v2)  ## Interactive Test Client  Experiment with live APIs using the **[Interactive Test Client](/v3/swagger)** .  ## Authentication Include your API key in the as the `accountKey` query parameter or `X-API-KEY` http header.  ## Query Availability, Pricing and Secondary Products  1. **[listSites](/v3/swagger/static/index.html#/sites/listSites)** Returns all sites, their short codes, office hours, and holidays for each fleet type. Using the information returned from `listSites`, you can create a request to `availabilitySearch`.  2. **[availabilitySearch](/v3/swagger/static/index.html#/trip/availabilitySearch)** Retrieves all vehicle categories that are potentially available for hire for the specified fleet type from the given locations, and given dates. Includes pricing and any mandatory fees. Note that pricing covers only the vehicle hire, excluding secondary and mandatory products by default.  2. **[tripInfo](/v3/swagger/static/index.html#/trip/tripInfo)** Provides additional trip information using the location and fleet category codes from `listSites` and `availabilitySearch`. The response includes available excess reduction and secondary products.  ## Create quotes, bookings and updating  existing bookings.  1. **[emailQuote](/v3/swagger/static/index.html#/quotes/emailQuote)** or **[createBooking](/v3/swagger/static/index.html#/reservations/createBooking)** Using details gathered from `tripInfo` create a booking or a quote. Quotes will hold pricing for a limited time, while bookings will be confirmed immediately. The **[convertQuote](/v3/swagger/static/index.html#/quotes/convertQuote)** endpoint may be called to convert a quote in to a booking  2. **[updateReservation](/v3/swagger/static/index.html#/reservations/updateReservation)** Optionally makes changes to an existing booking and quotes.
 *
 * The version of the OpenAPI document: 3.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { CatalogItem, ErrorResponse, FleetCategoryContent } from '../models/index';
import {
    CatalogItemFromJSON,
    CatalogItemToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FleetCategoryContentFromJSON,
    FleetCategoryContentToJSON,
} from '../models/index';
import * as runtime from '../runtime';

export interface GetFleetCategoriesRequest {
    fleetType?: string;
    countryCode?: GetFleetCategoriesCountryCodeEnum;
}

export interface GetFleetCategoryByCodeRequest {
    fleetCategoryCode: string;
    countryCode?: GetFleetCategoryByCodeCountryCodeEnum;
}

export interface GetFleetCategoryContentByCodeRequest {
    fleetCategoryCode: string;
    countryCode?: GetFleetCategoryContentByCodeCountryCodeEnum;
}

export interface ListFleetCategoryContentRequest {
    countryCode?: ListFleetCategoryContentCountryCodeEnum;
}

/**
 *
 */
export class FleetCategoriesApi extends runtime.BaseAPI {
    /**
     * Get a list of fleet categories
     */
    async getFleetCategoriesRaw(
        requestParameters: GetFleetCategoriesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<Array<CatalogItem>>> {
        const queryParameters: any = {};

        if (requestParameters['fleetType'] != null) {
            queryParameters['fleetType'] = requestParameters['fleetType'];
        }

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['X-API-KEY'] = await this.configuration.apiKey('X-API-KEY'); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('bearerAuth', []);

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request(
            {
                path: `/api/v3/fleet-categories`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CatalogItemFromJSON));
    }

    /**
     * Get a list of fleet categories
     */
    async getFleetCategories(
        fleetType?: string,
        countryCode?: GetFleetCategoriesCountryCodeEnum,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<Array<CatalogItem>> {
        const response = await this.getFleetCategoriesRaw({ fleetType: fleetType, countryCode: countryCode }, initOverrides);
        return await response.value();
    }

    /**
     * Get fleet category information
     */
    async getFleetCategoryByCodeRaw(
        requestParameters: GetFleetCategoryByCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<CatalogItem>> {
        if (requestParameters['fleetCategoryCode'] == null) {
            throw new runtime.RequiredError(
                'fleetCategoryCode',
                'Required parameter "fleetCategoryCode" was null or undefined when calling getFleetCategoryByCode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['X-API-KEY'] = await this.configuration.apiKey('X-API-KEY'); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('bearerAuth', []);

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request(
            {
                path: `/api/v3/fleet-categories/{fleetCategoryCode}`.replace(
                    `{${'fleetCategoryCode'}}`,
                    encodeURIComponent(String(requestParameters['fleetCategoryCode']))
                ),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => CatalogItemFromJSON(jsonValue));
    }

    /**
     * Get fleet category information
     */
    async getFleetCategoryByCode(
        fleetCategoryCode: string,
        countryCode?: GetFleetCategoryByCodeCountryCodeEnum,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<CatalogItem> {
        const response = await this.getFleetCategoryByCodeRaw({ fleetCategoryCode: fleetCategoryCode, countryCode: countryCode }, initOverrides);
        return await response.value();
    }

    /**
     * Get fleet category page information
     */
    async getFleetCategoryContentByCodeRaw(
        requestParameters: GetFleetCategoryContentByCodeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<FleetCategoryContent>> {
        if (requestParameters['fleetCategoryCode'] == null) {
            throw new runtime.RequiredError(
                'fleetCategoryCode',
                'Required parameter "fleetCategoryCode" was null or undefined when calling getFleetCategoryContentByCode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['X-API-KEY'] = await this.configuration.apiKey('X-API-KEY'); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('bearerAuth', []);

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request(
            {
                path: `/api/v3/fleet-categories/{fleetCategoryCode}/content`.replace(
                    `{${'fleetCategoryCode'}}`,
                    encodeURIComponent(String(requestParameters['fleetCategoryCode']))
                ),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => FleetCategoryContentFromJSON(jsonValue));
    }

    /**
     * Get fleet category page information
     */
    async getFleetCategoryContentByCode(
        fleetCategoryCode: string,
        countryCode?: GetFleetCategoryContentByCodeCountryCodeEnum,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<FleetCategoryContent> {
        const response = await this.getFleetCategoryContentByCodeRaw(
            { fleetCategoryCode: fleetCategoryCode, countryCode: countryCode },
            initOverrides
        );
        return await response.value();
    }

    /**
     * List fleet category page information
     */
    async listFleetCategoryContentRaw(
        requestParameters: ListFleetCategoryContentRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<Array<FleetCategoryContent>>> {
        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['X-API-KEY'] = await this.configuration.apiKey('X-API-KEY'); // apiKeyAuth authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('bearerAuth', []);

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request(
            {
                path: `/api/v3/fleet-categories/content`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FleetCategoryContentFromJSON));
    }

    /**
     * List fleet category page information
     */
    async listFleetCategoryContent(
        countryCode?: ListFleetCategoryContentCountryCodeEnum,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<Array<FleetCategoryContent>> {
        const response = await this.listFleetCategoryContentRaw({ countryCode: countryCode }, initOverrides);
        return await response.value();
    }
}

/**
 * @export
 */
export const GetFleetCategoriesCountryCodeEnum = {
    All: 'all',
    Au: 'au',
    Nz: 'nz',
} as const;
export type GetFleetCategoriesCountryCodeEnum = (typeof GetFleetCategoriesCountryCodeEnum)[keyof typeof GetFleetCategoriesCountryCodeEnum];
/**
 * @export
 */
export const GetFleetCategoryByCodeCountryCodeEnum = {
    All: 'all',
    Au: 'au',
    Nz: 'nz',
} as const;
export type GetFleetCategoryByCodeCountryCodeEnum =
    (typeof GetFleetCategoryByCodeCountryCodeEnum)[keyof typeof GetFleetCategoryByCodeCountryCodeEnum];
/**
 * @export
 */
export const GetFleetCategoryContentByCodeCountryCodeEnum = {
    All: 'all',
    Au: 'au',
    Nz: 'nz',
} as const;
export type GetFleetCategoryContentByCodeCountryCodeEnum =
    (typeof GetFleetCategoryContentByCodeCountryCodeEnum)[keyof typeof GetFleetCategoryContentByCodeCountryCodeEnum];
/**
 * @export
 */
export const ListFleetCategoryContentCountryCodeEnum = {
    All: 'all',
    Au: 'au',
    Nz: 'nz',
} as const;
export type ListFleetCategoryContentCountryCodeEnum =
    (typeof ListFleetCategoryContentCountryCodeEnum)[keyof typeof ListFleetCategoryContentCountryCodeEnum];
